import React from "react";
import './App.css';
import Content from "./content";
// import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import MachineDeepLearning from './components/Event_about/inner_pages/machine&deep-learning/machine&deep-learning.jsx'
import NLP from './components/Event_about/inner_pages/nlp/nlp.jsx'
import Bootcamp from './components/Event_about/inner_pages/bootcamp/bootcamp.jsx'
import Kickstarter from './components/Event_about/inner_pages/kick-start/kick-start.jsx'
import MLOps from './components/Event_about/inner_pages/MLOps/MLOps.jsx'
import Footer from './components/footer/Footer.jsx';
import Header from './components/Header/Header';

const App = () => {
  window.location.href = 'https://events.geekle.us/data-science2/';

  return (
    <Switch>
      <Router>
        <main>
          <Route exact path="/data-science/">
            <Content />
          </Route>
          <Route path="/data-science/machine&deep-learning">
            <MachineDeepLearning />
          </Route>
          <Route path="/data-science/nlp">
            <NLP />
          </Route>
          <Route path="/data-science/mlops">
            <MLOps />
          </Route>
          <Route path="/data-science/kickstarter">
            <Kickstarter />
          </Route>
          <Route path="/data-science/bootcamp">
            <Bootcamp />
          </Route>
          <Footer />
        </main>
      </Router>
    </Switch>
  );
}

export default App;